import { render, staticRenderFns } from "./ParamView.vue?vue&type=template&id=171dcd93&scoped=true"
import script from "./ParamView.vue?vue&type=script&lang=js"
export * from "./ParamView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dcd93",
  null
  
)

export default component.exports